<template>
  <div style="text-align: center">
    <div class="header-title">{{title}}</div>
  </div>
</template>

<script>
  export default {
    name: 'DocumentHeader',
    props: {
      title: String
    }
  }
</script>

<style lang="scss" scoped>
.header-title{
  height: 76px;
  line-height: 76px;
  display: inline-block;
  padding: 0 40px;
  font-size: 40px;
  font-weight: 500;
  color: #1E1E28;
  position: relative;
  &:before{
    content: '';
    width: 20px;
    height: 20px;
    background: url("./imgs/img_arrowleft.svg");
    background-size: cover;
    position: absolute;
    bottom: 0;
    left: 0;
  }
  &:after{
    content: '';
    width: 20px;
    height: 20px;
    background: url("./imgs/img_arrowright.svg");
    background-size: cover;
    position: absolute;
    top: 0;
    right: 0;
  }
}
</style>
